// extracted by mini-css-extract-plugin
module.exports = {"selectors":"MatchLineup_selectors__2bCLG","selectorButton":"MatchLineup_selectorButton__483Ef","selectorName":"MatchLineup_selectorName__t2WtX"};